// src/components/HR/utils/auth.js
// Shared utility to extract org_id and user_id from session auth state.
import { getAuthToken, getStoredOrgId, getStoredRole, getStoredUser } from '../../api';

export function getOrgId() {
    try {
        const token = getAuthToken();
        if (token) {
            const payload = JSON.parse(atob(token.split(".")[1]));
            const fromToken = payload.org_id || payload.organization_id || null;
            if (fromToken) return fromToken;
        }
    } catch { /* fall through */ }

    try {
        const stored = getStoredOrgId();
        if (stored) return parseInt(stored, 10);
    } catch { /* fall through */ }

    try {
        const user = getStoredUser() || {};
        return user.org_id || null;
    } catch {
        return null;
    }
}

export function getUserId() {
    try {
        const token = getAuthToken();
        if (!token) return null;
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.sub || payload.user_id || null;
    } catch {
        return null;
    }
}

/**
 * Get the current user's role from JWT or localStorage.
 * Returns uppercase string: "ADMIN", "HR_MANAGER", "HR_STAFF", "EMPLOYEE", etc.
 */
export function getUserRole() {
    try {
        const token = getAuthToken();
        if (token) {
            const payload = JSON.parse(atob(token.split(".")[1]));
            const role = payload.role || payload.user_role || null;
            if (role) return String(role).trim().toUpperCase();
        }
    } catch { /* fall through */ }

    try {
        const user = getStoredUser() || {};
        const role = user.role || user.user_role || null;
        if (role) return String(role).trim().toUpperCase();
    } catch { /* fall through */ }

    try {
        const stored = getStoredRole();
        if (stored) return String(stored).trim().toUpperCase();
    } catch { /* fall through */ }

    return "EMPLOYEE";
}

/**
 * Check if the current user can perform write operations (add/edit/delete).
 * HR management roles can write. We also allow HR_EXECUTIVE / HR_STAFF here
 * because worker onboarding is part of the day-to-day HR flow in this module.
 */
export function canWrite() {
    const role = getUserRole();
    return ["ADMIN", "ORG_ADMIN", "SUPER_ADMIN", "HR_MANAGER", "HR_ADMIN", "HR_EXECUTIVE", "HR_STAFF"].includes(role);
}
